import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import Draggable from "react-draggable";
import Select from "react-select";
import swal from "sweetalert";
import {
  customMultiValue,
  customOption,
  LoadingSpinner,
} from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";
import { ApiFinance } from "../ApiFinance";

const UpdateFinanceAccountCategories = ({
  setUpdateModal,
  financeCategoryId,
  previouslySelectedFinanceAccountCategories,
  reload,
  setReload,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [financeAccountCategories, setFinanceAccountCategories] = useState([]);
  const [
    selectedFinanceAccountCategories,
    setSelectedFinanceAccountCategories,
  ] = useState(previouslySelectedFinanceAccountCategories || []);
  const [errors, setErrors] = useState({
    selectedFinanceAccountCategories: "",
  });
  const toggle = () => setUpdateModal(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.selectedFinanceAccountCategories =
      selectedFinanceAccountCategories.length > 0
        ? ""
        : t("common_field_required_error");

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetFinanceAccountCategoriesList()
      .then((res) => {
        setFinanceAccountCategories(res.data);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: err,
          text: err.response.data,
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
      });
  }, []);

  const handleSelectFinanceAccountCategories = (selectedOptions) => {
    setSelectedFinanceAccountCategories(selectedOptions || []);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    ApiFinance()
      .UpdateFinanceAccountCategories(
        financeCategoryId,
        selectedFinanceAccountCategories
      )
      .then(() => {
        swal({
          title: t("finance_finance_account_categories_updated"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "success",
          buttons: "OK",
        });
        setReload(!reload);
        toggle();
      })
      .catch((err) => {
        swal({
          title: err.message || "Something went wrong",
          text: err.response?.data || "",
          icon: "error",
          buttons: "OK",
        });
        toggle();
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {
              <GetLanguageString props="finance_tab_finance_account_update_categories" />
            }
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <FormGroup>
                  <Label className="col-form-label">
                    {
                      <GetLanguageString props="finance_tab_finance_account_select_categories" />
                    }
                  </Label>
                  <Select
                    components={{
                      Option: customOption,
                      MultiValue: customMultiValue,
                    }}
                    options={financeAccountCategories}
                    value={selectedFinanceAccountCategories}
                    className="basic-multi-select no-drag"
                    classNamePrefix="select"
                    isMulti
                    onChange={handleSelectFinanceAccountCategories}
                    {...(errors.selectedFinanceAccountCategories && {
                      invalid: true,
                    })}
                  />
                  {errors.selectedFinanceAccountCategories && (
                    <h4 className="text-error">
                      {errors.selectedFinanceAccountCategories}
                    </h4>
                  )}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" type="submit">
                  {<GetLanguageString props="update" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default UpdateFinanceAccountCategories;
